export default __webpack_public_path__ + "static/media/francja.81c1ea46.jpg";